export default "__VITE_ASSET__95559a7f__"